<template>
  <div class="sidebar-accordion">
    <button type="button" class="accordion-header" :aria-expanded="selfOpen" @click="toggle">
      <span class="accordion-title">{{ title }}</span>
      <!-- Résumé affiché à côté du titre uniquement quand la section est repliée -->
      <span v-if="!selfOpen && $slots.summary" class="accordion-summary"><slot name="summary"></slot></span>
      <span class="accordion-chevron fas" :class="selfOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></span>
    </button>
    <!-- v-show : le contenu reste monté (champs rattachés au formulaire) même replié -->
    <div v-show="selfOpen" class="accordion-body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import {library} from '@fortawesome/fontawesome-svg-core';
import {faChevronDown, faChevronUp} from "@fortawesome/free-solid-svg-icons";

library.add(faChevronDown, faChevronUp);

// Section repliable des colonnes latérales : seul le titre (et un éventuel résumé) est visible tant qu'elle n'est pas ouverte.
//  - defaultOpen    : état initial quand le parent ne pilote pas l'état
//  - open           : (optionnel) état piloté par le parent, prioritaire sur defaultOpen
//  - toggleCallback : (optionnel) appelée avec le nouvel état à chaque clic, pour que le parent puisse le conserver
export default {
  name: 'SidebarAccordion',
  props: {
    title: {type: String, required: true},
    defaultOpen: {type: Boolean, default: false},
    open: {type: Boolean, default: undefined},
    toggleCallback: {type: Function, default: undefined},
  },
  data() {
    return {
      selfOpen: this.open !== undefined ? this.open : this.defaultOpen,
    };
  },
  watch: {
    open(value) {
      if (value !== undefined) this.selfOpen = value;
    },
  },
  methods: {
    toggle() {
      this.selfOpen = !this.selfOpen;
      if (this.toggleCallback) this.toggleCallback(this.selfOpen);
    },
  },
};
</script>

<style lang="stylus" scoped>
.accordion-header
  display flex
  align-items center
  gap 6px
  width 100%
  padding 4px 0
  border 0
  background none
  font-family inherit
  font-size 11.5px
  font-weight 800
  letter-spacing 0.05em
  text-transform uppercase
  color #3a4250
  text-align left
  cursor pointer
  &:hover
    color #14181f

.accordion-title
  flex 0 0 auto

.accordion-summary
  flex 1 1 auto
  min-width 0
  overflow hidden
  text-overflow ellipsis
  white-space nowrap
  font-size 12px
  font-weight 700
  letter-spacing 0
  text-transform none
  color #3d4450

.accordion-chevron
  flex 0 0 auto
  margin-left auto

.accordion-body
  padding-top 6px
</style>
